import { useAngebotsmailVorschau, useZustimmungMail } from "../../hooks/useVertraege";
import { fehlertext } from "../../lib/fehler";

/**
 * Angebotsmail: erst zeigen, dann senden (Testlauf 06.10.2026).
 *
 * Gebraucht am Ende des Wizards („Angebot senden") und auf der Vertragsseite
 * („Erneut senden"). Die Mail trägt seit Etappe C nur noch den Kundenlink.
 */
export default function AngebotSenden({ vertragId, onGesendet, onAbbrechen, abbrechenText = "Abbrechen" }: {
  vertragId: string;
  onGesendet: (an: string) => void;
  onAbbrechen: () => void;
  abbrechenText?: string;
}) {
  const vorschau = useAngebotsmailVorschau(vertragId, true);
  const mailen = useZustimmungMail(vertragId);

  return (
    <div className="pf-card pf-mailvorschau">
      {vorschau.isLoading ? <div>Lade Vorschau…</div> : vorschau.error ? (
        <div className="pk-fehler">{fehlertext(vorschau.error)}</div>
      ) : vorschau.data && (
        <>
          <div className="pf-mailvorschau-kopf"><b>An:</b> {vorschau.data.an}</div>
          <div className="pf-mailvorschau-kopf"><b>Betreff:</b> {vorschau.data.betreff}</div>
          <pre className="pf-mailvorschau-text">{vorschau.data.text}</pre>
        </>
      )}
      {mailen.error && <p className="pk-fehler">{fehlertext(mailen.error) || "Senden fehlgeschlagen."}</p>}
      <div className="pf-mailvorschau-knoepfe">
        <button type="button" className="pf-btn" disabled={mailen.isPending || !vorschau.data}
          onClick={() => mailen.mutateAsync().then(r => onGesendet(r.gesendet_an)).catch(() => undefined)}>
          {mailen.isPending ? "Sende…" : "Jetzt senden"}
        </button>
        <button type="button" className="pf-btn is-ghost" onClick={onAbbrechen}>{abbrechenText}</button>
      </div>
    </div>
  );
}
